import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import convertNumbThousand from "../../../utils/convertNumbThousand";
import ButtonPrimary from "../../Button/ButtonPrimary";
import customTime from "../../../utils/customTime";
import calculateTime from "../../../utils/calculateTime";

import airarabiaLogo from "../../../images/flight-logo/airarabia.png";
import seat from "../../../images/seat.png";
import { getAirArabiaServiceCharge } from "../Service/helper.airarabia";

const FlightResultAirArabia = ({
  flight,
  setLoading,
  query,
  company,
  corporate,
  discount,
  charges,
  rateDifference,
  originalPath,
  setIsAirArabiaReturn,
  isAirArabiaReturn,
  setAirArabiaOneWayData,
  isRoundTrip,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [serviceCharge, setServiceCharge] = useState(0);

  const searchParams = new URLSearchParams(query);
  const adults = searchParams.get("adults");
  const labors = searchParams.get("labors");
  const children = searchParams.get("children");
  const infants = searchParams.get("infants");

  const navigate = useNavigate();

  useEffect(() => {
    const passengerCount = {
      ADT: +adults || 1,
      CHD: +children || 0,
    };
    const cabinPrice = flight.data.cabinPrices[0];
    const serviceCharge = getAirArabiaServiceCharge(
      passengerCount,
      cabinPrice,
      company,
      corporate,
      discount,
      {},
    );
    setServiceCharge(serviceCharge);
  }, [
    adults,
    children,
    company,
    corporate,
    discount,
    flight.cabin,
    flight.data.cabinPrices,
  ]);

  const hasReturnFlight = !!flight?.returnFlight?.data?.flightSegments?.length;
  const outboundSegments = flight?.data?.flightSegments || [];
  const returnSegments = hasReturnFlight
    ? flight.returnFlight.data.flightSegments
    : [];
  const outboundPrice = flight?.data?.cabinPrices?.[0]?.price || 0;
  const returnPrice =
    (hasReturnFlight && flight?.returnFlight?.data?.cabinPrices?.[0]?.price) ||
    0;
  const combinedPrice = Number(
    flight?.totalPrice ?? outboundPrice + returnPrice,
  );

  if (!flight?.data) {
    return (
      <div className="flex flex-col justify-center items-center py-12">
        <div className="mb-4 text-2xl font-bold text-main">
          No Flights Found
        </div>
        <div className="text-neutral-500">
          Please try different search criteria
        </div>
      </div>
    );
  }
  function totalPrice(price) {
    const airPrice = parseFloat(price.toFixed(2));

    let result =
      rateDifference > 1 ? (airPrice * rateDifference).toFixed(2) : airPrice;

    result = parseFloat(result) + serviceCharge;
    return convertNumbThousand(result);
  }

  const renderSummaryRow = ({ segments, showPrice = false }) => {
    if (!segments?.length) return null;
    const firstSeg = segments[0];
    const lastSeg = segments[segments.length - 1];

    const stopsText =
      segments.length > 1
        ? `${segments.length - 1} Stops (${
            segments[0].destination.airportCode
          }${
            segments.length - 1 > 1
              ? `, ${segments[1].destination.airportCode}`
              : ""
          })`
        : "Direct";

    return (
      <div
        className={` space-y-6  ${
          isRoundTrip
            ? "grid lg:grid-cols-5"
            : "flex justify-between md:flex-row"
        } sm:items-center sm:space-y-0`}
      >
        <div className="flex-shrink-0 w-24 lg:w-32">
          <img src={airarabiaLogo} className="w-24" alt="" />
        </div>

        {/* FOR MOBILE RESPONSIVE */}
        <div className="block space-y-1 md:hidden">
          <div className="flex items-center font-semibold">
            <div>
              <span>
                <span>{customTime(firstSeg.departureDateTimeLocal)} </span>
              </span>

              <span className="flex items-center mt-0.5 text-sm font-normal text-neutral-500">
                {firstSeg.origin.airportCode}
              </span>
            </div>
            <span className="flex justify-center w-12">
              <i className="text-2xl las la-long-arrow-alt-right"></i>
            </span>
            <div>
              <span>
                <span>{customTime(lastSeg.arrivalDateTimeLocal)} </span>
              </span>
              <span className="flex items-center mt-0.5 text-sm font-normal text-neutral-500">
                {lastSeg.destination.airportCode}
              </span>
            </div>
            <div className="w-24"></div>

            <div className="flex flex-col justify-between items-start">
              <div className="mt-0.5 text-sm font-normal text-black">
                <span className="VG3hNb">{stopsText}</span>
              </div>

              <div className="mt-0.5 text-xs font-normal sm:text-sm text-neutral-500">
                Flight- {firstSeg.flightNumber}
              </div>
            </div>
          </div>
        </div>

        <div className="hidden md:block flex-[1] mx-2">
          <div className="text-lg font-medium text-black">
            {segments.length > 1 ? (
              <span>
                {customTime(firstSeg.departureDateTimeLocal)}
                {" - "}
                {customTime(lastSeg.arrivalDateTimeLocal)}
              </span>
            ) : (
              customTime(firstSeg.departureDateTimeLocal) +
              " - " +
              customTime(lastSeg.arrivalDateTimeLocal)
            )}
          </div>
          <div className="mt-0.5 text-sm font-normal text-neutral-500">
            Air Arabia
          </div>
        </div>

        <div className="hidden flex-[1] whitespace-nowrap lg:block mx-2">
          <div className="text-lg font-medium text-black">
            {firstSeg.origin.airportCode} - {lastSeg.destination.airportCode}
          </div>
          <div className="mt-0.5 text-sm font-normal text-neutral-500">
            {moment(lastSeg.arrivalDateTimeLocal).diff(
              firstSeg.departureDateTimeLocal,
              "hours",
            )}{" "}
            hours{" "}
            {moment(lastSeg.arrivalDateTimeLocal).diff(
              firstSeg.departureDateTimeLocal,
              "minutes",
            ) % 60}{" "}
            minutes
          </div>
        </div>

        {/* TYPE */}
        <div className="hidden flex-[2] whitespace-nowrap md:block">
          <div className="text-lg font-medium text-black">{stopsText}</div>
          <div className="mt-0.5 text-sm font-normal text-neutral-500"></div>
        </div>

        {/* PRICE */}
        {/* <div className="hidden flex-col items-start text-right sm:ml-auto sm:items-end md:flex">
          <div className="mt-0.5 text-xs font-normal sm:text-sm text-neutral-500">
            Flight- {firstSeg.flightNumber}
          </div>
        </div> */}
      </div>
    );
  };

  const onSelectFlight = () => {
    let data = null;
    const passengers = {
      ADT: adults || 1,
      LBR: labors || 0,
      CHD: children || 0,
      INF: infants || 0,
    };

    if (hasReturnFlight) {
      data = {
        segments: outboundSegments.map((seg) => ({
          origin: seg.origin.airportCode,
          destination: seg.destination.airportCode,
          departureDate: seg.departureDateTimeLocal,
          arrivalDate: seg.arrivalDateTimeLocal,
          directionInd: "Return",
          FlightNumber: seg.flightNumber,
          airlineCode: seg.flightNumber?.slice(0, 2),
        })),
        returnSegments: returnSegments.map((seg) => ({
          origin: seg.origin.airportCode,
          destination: seg.destination.airportCode,
          departureDate: seg.departureDateTimeLocal,
          arrivalDate: seg.arrivalDateTimeLocal,
          directionInd: "Return",
          FlightNumber: seg.flightNumber,
          airlineCode: seg.flightNumber?.slice(0, 2),
        })),
        passengers,
      };
    }
    // else if (originalPath.length > 1 && isAirArabiaReturn === true) {
    //   console.log(airArabiaOneWayData.segmentData.segments);
    //   data = {
    //     segments: [...airArabiaOneWayData.segmentData.segments],
    //     returnSegments: [
    //       ...flight.data.flightSegments.map((seg) => ({
    //         origin: seg.origin.airportCode,
    //         destination: seg.destination.airportCode,
    //         departureDate: seg.departureDateTimeLocal,
    //         arrivalDate: seg.arrivalDateTimeLocal,
    //         directionInd: "Return",
    //         FlightNumber: seg.flightNumber,
    //         airlineCode: seg.flightNumber?.slice(0, 2),
    //       })),
    //     ],
    //     passengers,
    //   };
    // }
    else {
      data = {
        segments: flight.data.flightSegments.map((seg) => ({
          origin: seg.origin.airportCode,
          destination: seg.destination.airportCode,
          departureDate: seg.departureDateTimeLocal,
          arrivalDate: seg.arrivalDateTimeLocal,
          directionInd: "OneWay",
          FlightNumber: seg.flightNumber,
          airlineCode: seg.flightNumber?.slice(0, 2),
        })),
        passengers,
      };
    }

    if (hasReturnFlight) {
      navigate(`/airarabia-pricing?${query}`, {
        state: {
          segmentData: data,
          queryURL: query,
          bookingDetails: [...outboundSegments, ...returnSegments],
          cabin: flight?.cabin,
          charges: serviceCharge,
          originalPath,
          passengers,
          currency: flight?.currency,
          rateDifference,
        },
      });
    } else if (originalPath.length > 1 && isAirArabiaReturn === false) {
      setIsAirArabiaReturn(true);
      setAirArabiaOneWayData({
        segmentData: data,
        bookingDetails: flight.data.flightSegments,
      });
    } else {
      navigate(`/airarabia-pricing?${query}`, {
        state: {
          segmentData: data,
          queryURL: query,
          bookingDetails: flight.data.flightSegments,
          cabin: flight?.cabin,
          charges: serviceCharge,
          originalPath,
          passengers,
          currency: flight?.currency,
          rateDifference,
        },
      });
    }
  };

  const renderDetailTop = (seg, btnVisible, cabinLabel = flight?.cabin) => {
    return (
      <div>
        <div className="flex flex-col md:flex-row">
          <div className="flex-shrink-0 w-24 md:w-20 lg:w-24 md:pt-3">
            <img src={airarabiaLogo} className="w-15" alt="" />
          </div>
          <div className="flex my-2 md:my-0 lg:w-72">
            <div className="flex flex-col flex-shrink-0 items-center py-2">
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
              <span className="block flex-grow my-1 border-l border-dashed border-neutral-400"></span>
              <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
            </div>
            <div className="ml-4 space-y-10 text-sm">
              <>
                <div className="flex flex-col space-y-1">
                  <span className="text-neutral-500 dark:text-neutral-400">
                    <>{customTime(seg.departureDateTimeLocal)}</>
                  </span>
                  <span className="font-semibold text-black">
                    {seg.origin.airportCode}
                  </span>
                </div>
                <div className="flex flex-col space-y-1">
                  <span className="text-neutral-500 dark:text-neutral-400">
                    {customTime(seg.arrivalDateTimeLocal)}
                  </span>
                  <span className="font-semibold text-black">
                    {seg.destination.airportCode}
                  </span>
                </div>
              </>
            </div>
          </div>
          <div className="border-l border-neutral-200 dark:border-neutral-700 md:mx-6 lg:ml-10"></div>
          <ul className="space-y-1 text-sm text-neutral-500 dark:text-neutral-400 md:space-y-2">
            <li>
              Flight time:{" "}
              <span>
                {calculateTime(
                  seg.arrivalDateTimeLocal,
                  seg.departureDateTimeLocal,
                )}
              </span>
            </li>
            {/* <li>
                Flight Class: {flight.data.flightSegments[index].cabinClass}
              </li> */}
            <li>Flight Number: {seg.flightNumber}</li>
            <li>Aircraft: {seg.aircraftModel}</li>
            <li>Booking Class: {cabinLabel}</li>
            {seg?.availablePaxCounts?.some((pax) => pax?.count < 10) && (
              <li className="flex items-center">
                Seat Left:{" "}
                <span className="px-1.5 ml-2 font-semibold text-white rounded-full bg-main-900">
                  {seg?.availablePaxCounts?.[0]?.count}
                </span>{" "}
                <img src={seat} alt="seat" className="w-5 h-5" />
                left
              </li>
            )}
          </ul>
          {btnVisible && (
            <>
              <div className="mx-auto"></div>
              <div className="flex flex-col px-6 py-2 mt-auto">
                <ButtonPrimary onClick={onSelectFlight}>Select</ButtonPrimary>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  const renderSegmentSection = (
    segments,
    showButtonOnLast,
    label,
    cabinLabel,
  ) => {
    if (!segments?.length) return null;
    return (
      <div>
        {label && (
          <div className="mb-4 text-sm font-semibold text-neutral-700">
            {label}
          </div>
        )}
        {segments.map((seg, index) => (
          <div key={`${seg.flightNumber}-${index}`}>
            {renderDetailTop(
              seg,
              showButtonOnLast && index === segments.length - 1,
              cabinLabel,
            )}
            {index === segments.length - 1 ? null : (
              <div className="my-7 space-y-5 md:my-10 md:pl-24">
                <div className="border-t border-neutral-200 dark:border-neutral-700" />
                <div className="text-sm text-neutral-700 dark:text-neutral-300 md:text-base">
                  Transit time:{" "}
                  {calculateTime(
                    segments[index + 1].departureDateTimeLocal,
                    segments[index].arrivalDateTimeLocal,
                  )}
                </div>
                <div className="border-t border-neutral-200 dark:border-neutral-700" />
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };
  const renderDetail = () => {
    if (!isOpen) return null;

    return (
      <div className="p-4 space-y-8 rounded-2xl border md:p-8 border-neutral-200 dark:border-neutral-700">
        {renderSegmentSection(
          outboundSegments,
          !hasReturnFlight,
          hasReturnFlight ? "Onward flight" : null,
          flight?.cabin,
        )}
        {hasReturnFlight && (
          <>
            <div className="border-t border-neutral-200 dark:border-neutral-700" />
            {renderSegmentSection(
              returnSegments,
              true,
              "Return flight",
              flight?.returnFlight?.cabin || flight?.cabin,
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <div
      className={`overflow-hidden relative p-4 space-y-6 bg-white rounded-2xl border shadow transition-shadow nc-FlightCardgroup sm:p-6 border-neutral-100 hover:shadow-lg`}
      data-nc-id="FlightCard"
      onClick={() => {
        setIsOpen(!isOpen);
        localStorage.setItem("pairedRefs", JSON.stringify([]));
      }}
    >
      <div className={`relative md:pr-40`} data-nc-id="FlightCard">
        {/*  eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a href="##" className="absolute inset-0" />

        <span
          className={`absolute right-0 bottom-0  w-10 h-10 bg-neutral-50 dark:bg-neutral-800 rounded-full flex items-center justify-center cursor-pointer ${
            isOpen ? "transform -rotate-180" : ""
          }`}
          // onClick={() => setIsOpen(!isOpen)}
        >
          <i className="text-xl las la-angle-down"></i>
        </span>

        <div
          className={`absolute ${
            isRoundTrip ? "right-0" : "right-16"
          } top-2 md:top-1/3`}
        >
          <div className="text-xl font-semibold text-secondary-6000">
            {totalPrice(combinedPrice)} ETB
          </div>
        </div>

        <div className="space-y-6">
          {renderSummaryRow({
            segments: outboundSegments,
            showPrice: true,
          })}

          {flight.serviceErrors && flight.serviceErrors.length > 0 && (
            <div className="p-4 bg-red-50 rounded-lg border border-red-200 dark:bg-red-900/20 dark:border-red-800">
              <h4 className="mb-2 font-medium text-red-800 dark:text-red-200">
                Service Errors
              </h4>
              <ul className="text-sm text-red-700 dark:text-red-300">
                {flight.serviceErrors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}

          {hasReturnFlight && (
            <div className="pt-6 border-t border-neutral-200 dark:border-neutral-700">
              {renderSummaryRow({
                segments: returnSegments,
                showPrice: false,
              })}
            </div>
          )}
        </div>
      </div>
      {renderDetail()}
    </div>
  );
};

export default FlightResultAirArabia;
